import React, { useEffect, useState } from "react";
import { Space } from "antd";

import TableCustom from "src/components/Table/CustomTable";
import ButtonCircle from "src/components/MyButton/ButtonCircle";
import CB1 from "src/components/Modal/CB1";

// Cột hóa đơn bán hàng
const column = [
    {
        title: "TT",
        dataIndex: "index",
        key: "index",
        render: (_, record, i) => {
            return <>{i + 1}</>;
        },
    },
    {
        title: "Số hóa đơn",
        dataIndex: "invoiceNumber",
        key: "invoiceNumber",
    },
    {
        title: "Tên khách hàng",
        dataIndex: "customerName",
        key: "customerName",
    },
    {
        title: "Ngày hóa đơn",
        dataIndex: "invoiceDate",
        key: "invoiceDate",
    },
    {
        title: "Tổng tiền",
        dataIndex: "totalAmount",
        key: "totalAmount",
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
    },
];

const _dataSource = [
    {
        key: 1,
        invoiceNumber: "INV001",
        customerName: "Nguyễn Văn A",
        invoiceDate: "2024-08-01",
        totalAmount: 5000000,
        status: "Đã thanh toán",
    },
    {
        key: 2,
        invoiceNumber: "INV002",
        customerName: "Trần Thị B",
        invoiceDate: "2024-08-02",
        totalAmount: 10000000,
        status: "Chưa thanh toán",
    },
    {
        key: 3,
        invoiceNumber: "INV003",
        customerName: "Lê Văn C",
        invoiceDate: "2024-08-03",
        totalAmount: 7500000,
        status: "Đã thanh toán",
    },
];

function BillOfSaleComponent(props) {
    const [dataSource, setDataSource] = useState(_dataSource);
    const [dataSelected, setDataSelected] = useState([]);

    useEffect(() => {
        // Effect logic here if needed
    }, []);

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setDataSelected(selectedRows);
        },
    };

    return (
        <div>
            {!!dataSelected.length && (
                <ButtonCircle
                    style={{ marginRight: '10px', marginBottom: '10px' }}
                    title="Xóa hàng đã chọn"
                    iconName="delete-outline"
                    onClick={() => CB1({
                        title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
                        icon: "trashRed",
                        okText: "Đồng ý",
                        onOk: async close => {
                            // Logic to delete selected rows
                            close();
                        },
                    })}
                />
            )}
            <TableCustom
                isPrimary
                columns={column}
                dataSource={dataSource}
                showPagination
                rowSelection={{
                    type: "checkbox",
                    ...rowSelection,
                }}
                footerLeft={<div className="d-flex mt-20" />}
                widthScroll={1200}
                textEmpty="Không có dữ liệu!"
            />
        </div>
    );
}

export default BillOfSaleComponent;
